<template>
  <div class="common_bg device_history">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('lang.电表')" name="a"> </el-tab-pane>
      <el-tab-pane :label="$t('lang.水表')" name="b">
        <!-- <watermeter ref="wmeter"></watermeter> -->
      </el-tab-pane>
    </el-tabs>
    <transition name="fade" mode="out-in">
      <electric-meter
        v-if="activeName === 'a'"
        ref="electricMeter"
      ></electric-meter>
      <water-meter v-if="activeName === 'b'" ref="waterMeter"></water-meter>
    </transition>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ElectricMeter from "./electric-meter.vue";
import WaterMeter from "./water-meter.vue";
export default {
  components: { ElectricMeter, WaterMeter },
  data() {
    return {
      activeName: "a",
    };
  },
  methods: {
    ...mapActions({
      deviceListHistoryData: "ZD_DeviceListHistoryData",
    }),
    handleClick(tab, event) {
      switch (tab.index) {
        case "a":
          break;
        case "b":
          break;
      }
    },
  },
};
</script>

<style scoped lang='less'>
.device_history {
  height: calc(100% - 110px);
  overflow: hidden !important;
}
.el-form {
  .el-form-item {
    margin-right: 24px;
  }
}
/deep/ .el-tabs__header {
  margin-bottom: 0;
}
.payment_bottom {
  width: 100%;
  height: 60px;
  .bottom_page {
    position: absolute;
    bottom: 20px;
    right: 20px;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
